<template>
  <router-view/>
</template>

<style>
  @import '../src/assets/css/style.css';
  * {
    font-family: 'General Sans', sans-serif;
  }
</style>